module.exports = __webpack_public_path__ + "img/clock.0a4d529b.svg";